export default "__VITE_ASSET__Cdtxd0rD__"